import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../img/promptIcon.svg'


const _withScopeId = n => (_pushScopeId("data-v-33598d55"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "showIcon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    href: "",
    src: _imports_0
  })
], -1))
const _hoisted_3 = { class: "promptMess" }
const _hoisted_4 = { class: "toCancle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.visible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
      width: _ctx.width,
      "close-on-click-modal": false,
      "show-close": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(_ctx.info)), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toCancle && _ctx.toCancle(...args)))
            }, _toDisplayString(_ctx.$t("payPage.enterSubmit")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "width"])
  ]))
}